import React from "react";
import { Box, Typography } from "@mui/material";

const ProfilePage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        个人设置
      </Typography>
      <Typography variant="body1">此页面正在开发中...</Typography>
    </Box>
  );
};

export default ProfilePage;
